import React, {Component} from 'react';
import {
	filterServices,
	findByValue,
	getFilenameFromResponse,
	hasUserRight,
	showAxiosError,
	xsltEnumToInt,
	xsltTypeList,
	xsltTypeMap
} from "../../helper/helper";
import {request} from "../../helper/APIUtils";
import Table from "../../components/Table/Table";
import SweetAlert from 'react-bootstrap-sweetalert';
import XsltEditCreateModal from "./components/XsltEditCreateModal";
import MediaViewer from "../einvoice/MediaViewer";
import NavBarKS from "../../components/NavBarKS";
import Select from "../../local_node_modules/react-select"
import {UserRightsEnum} from "../../helper/enums";
import StickButton from "../../components/StickButton";
import {VirtualHost} from "../../constants";

class XsltList extends Component {
	constructor(props) {
		super(props);
		this.state = {
			alert: null,
			url: null,
			mediaModal: false,
			xslts: [],
			type: null,
			typeList: [],
			xsltTypeMap:xsltTypeMap,
			loading: false,
			isLoading:false,
			total: 0,
			page: 0,
			size: 10,
			isOpen: false,
			modelXslt: undefined,
			selectedXslt:null,
			serviceList:[],
			customerId:null

		};
		this.fetchData = this.fetchData.bind(this);
		this.handleUpload = this.handleUpload.bind(this);
		this.handleEdit = this.handleEdit.bind(this);
		this.handleDelete = this.handleDelete.bind(this);
		this.handleShow = this.handleShow.bind(this);
		this.setMediaViewer = this.setMediaViewer.bind(this);
		this.toggleModal = this.toggleModal.bind(this)
		this.handleCreate= this.handleCreate.bind(this);
		this.fetchUserServices=this.fetchUserServices.bind(this);
	}

	componentDidMount() {
		this.fetchUserServices();
		this.setState({typeList: xsltTypeList()});
	}

	fetchUserServices() {
		let self = this;
		let params = {
			url: `/signature/alias/getServices`,
			method: "get",
		};
		request(params)
			.then(function (response) {
				let serviceList=response.data;
				self.setState({serviceList: serviceList.filter(item => item != 3 && item != 4 && item != 5)});
			}).catch(function (error) {
			if (error.response === undefined) {
				showAxiosError({message: "Şuan işleminiz gerçekleştirilemiyor."});
			} else {
				let enc = new TextDecoder("utf-8");
				showAxiosError({message: enc.decode(error.response.data)});
			}
		});

	}

	handleDownload(row) {
		let self = this;

		let formData = new FormData();
		formData.append("id", row.recordId);
		formData.append("customerId", this.state.customerId === null ? 0 : this.state.customerId);

		let params = {
			url: `/xslt/download`,
			responseType: 'arraybuffer',
			method: "post",
			data: formData
		};

		request(params).then((response) => {

			let blob = new Blob([response.data], {type: response.headers["content-type"]});
			let urlCreator = window.URL || window.webkitURL;
			let url = urlCreator.createObjectURL(blob);

			let filename = getFilenameFromResponse(response);

			let a = document.createElement("a");
			document.body.appendChild(a);
			a.style = "display: none";
			a.href = url;
			a.download = filename;
			a.click();
			document.body.removeChild(a);

		}).catch(error => {
			showAxiosError(error);
		})


	}

	handleShow(row) {
		let self = this;
		let formData = new FormData();
		formData.append("id", row.recordId);
		formData.append("type", xsltEnumToInt(row.xsltType));
		formData.append("isHalXml", false)
		formData.append("customerId", this.state.customerId === null ? 0 : this.state.customerId)

		let params = {
			url: `/xslt/preview`,
			responseType: 'arraybuffer',
			method: "post",
			data: formData
		};
		self.setState({mediaModal: true, title: "Önizleme"});

		request(params)
			.then(function (response) {
				let blob = new Blob([response.data], {type: response.headers["content-type"]});
				let urlCreator = window.URL || window.webkitURL;
				let url = urlCreator.createObjectURL(blob);
				self.setState({url: url});

			}).catch(function (error) {
			if (error.response === undefined) {
				showAxiosError({message: "Şuan işleminiz gerçekleştirilemiyor."});
			} else {
				let enc = new TextDecoder("utf-8");
				showAxiosError({message: enc.decode(error.response.data)});
			}
			self.setState({mediaModal: false, title: null});
		});

	}

	setMediaViewer() {
		this.setState({url: null, mediaModal: false});
	}

	toggleModal() {
		if (this.state.isOpen) {
			this.fetchData(undefined, undefined, this.state.page, this.state.size)
		}
		this.setState({isOpen: !this.state.isOpen});
	}

	handleEdit(row) {
		let customerId = this.state.customerId;
		if(!this.state.serviceList.includes(xsltEnumToInt(row.xsltType))){return;}
		if (row.isEditable===false){
			let modelXslt = {
				id: row.recordId,
				filename: row.xsltFilename,
				type: xsltEnumToInt(row.xsltType),
				isDefault: row.isDefault
			};
			this.setState({isLoading:true,modelXslt}, () => this.toggleModal());
		}
		else {
			let self = this;
			let params = {
				url: customerId === null || customerId === 0 ?  `/xslt/findById/${row.recordId}` :  `/xslt/findByIdAndCustomerId/${row.recordId}/${this.state.customerId}`,
				method: "get",
			};
			request(params)
				.then(function (response) {
					self.setState({isLoading:false,selectedXslt: response.data}, () => self.props.history.push({
						pathname: '/xsltOlustur',
						mode:'edit',
						selectedXslt: self.state.selectedXslt,
						serviceList:self.state.serviceList,
						customerId:self.state.customerId
					}));
				}).catch(function (error) {
				self.setState({isLoading:false});
				if (error.response === undefined) {
					showAxiosError({message: "Şuan işleminiz gerçekleştirilemiyor."});
				} else {
					let enc = new TextDecoder("utf-8");
					showAxiosError({message: enc.decode(error.response.data)});
				}
			});
		}
	}

	handleUpload() {
		let modelXslt = {
			filename: '',
			type: this.state.type,
			isDefault: 0,
		};

		this.setState({modelXslt}, () => this.toggleModal())
	}

	handleCreate() {

		let modelXslt = {
			filename: '',
			type: this.state.type,
			isDefault: 0,
		};

		this.setState({modelXslt}, () =>  this.props.history.push({pathname:'/xsltOlustur',mode:'create',serviceList:this.state.serviceList,type:this.state.type, customerId: this.state.customerId}));
	}

	handleDelete(row) {
		let self = this;

		let formData = new FormData();
		formData.append("id", row.recordId);
		formData.append("customerId", this.state.customerId === null ? 0 : this.state.customerId)

		let params = {
			url: '/xslt/delete',
			method: "post",
			data: formData,
		};

		request(params)
			.then(function (response) {
				self.setState({
					loading: false,
					alert: (
						<SweetAlert confirmBtnText="Tamam"
									showCancel={false}
									confirmBtnBsStyle="info"
									title="Kayıt silindi"
									onConfirm={() => self.setState({alert: null}, () => self.fetchData(undefined, undefined, self.state.page, self.state.size))}>
						</SweetAlert>
					)
				});
			}).catch(function (error) {
			showAxiosError(error);
		});
	}

	openDeleteConfirmModal(row) {
		this.setState({
			alert: (
				<SweetAlert showCancel warning
							confirmBtnText="Evet"
							cancelBtnText="Hayır"
							confirmBtnBsStyle="danger"
							cancelBtnBsStyle="default"
							title="Emin Misiniz?"
							onConfirm={() => this.handleDelete(row)}
							onCancel={() => this.setState({alert: null})}
				>
					{"XSLT silinecek."}
				</SweetAlert>
			)
		});
	}

	fetchData(accessor, direction, page, size) {
		let self = this;
		if (this.props.match.params.customerId !== undefined){
			this.setState({customerId: this.props.match.params.customerId})
		}
		let customerId = this.props.match.params.customerId !== undefined ? this.props.match.params.customerId : null;
		let sortStr = accessor !== undefined ? ('&sort=' + accessor + ',' + direction) : '';
		let params = null;
		if (customerId === null) {
			params = {
				url:
					(this.state.type) ?
						`/xslt/fetch?type=${this.state.type}&page=${page}&size=${size}${sortStr}`
						:
						`/xslt/fetch?&page=${page}&size=${size}${sortStr}`,
				method: "get",
			};
		} else {
			params = {
				url:
					(this.state.type) ?
						`/xslt/fetchByCustomerId?type=${this.state.type}&customerId=${customerId}&page=${page}&size=${size}${sortStr}`
						:
						`/xslt/fetchByCustomerId?customerId=${customerId}&page=${page}&size=${size}${sortStr}`,
				method: "get",
			}
		}

		self.setState({loading: true});
		request(params)
			.then(function (response) {
				self.setState({
					page: page,
					size: size,
					total: response.data.totalElements,
					xslts: response.data.content,
					loading: false,
				});
			}).catch(function (error) {
			self.setState({loading: false});
			showAxiosError(error);
		});
	}

	render() {
		const {customers} = this.state;
		const source = VirtualHost.conf.resourcePrefix;


		let filtered=[];
		let allServices=[];
		allServices.push({value:null,label:'Tümü'});
		filtered=filterServices(this.state.xsltTypeMap,this.state.serviceList);
		allServices=allServices.concat(filtered);
		const columns = [
			{
				Header: "XSLT Adı",
				title: "XSLT Adı",
				accessor: "xsltFilename"
			},
			{
				Header: "Türü",
				title: "Türü",
				accessor: "xsltType",
				Cell: row => this.state.xsltTypeMap && findByValue(this.state.xsltTypeMap,xsltEnumToInt(row.xsltType)).label
			},
			{
				Header: "Varsayılan Bilgisi",
				title: "Varsayılan Bilgisi",
				accessor: "isDefault",
				Cell: row => row.isDefault ? "Varsayılan" : ""
			},
			{
				Header: "İşlemler",
				title: "İşlemler",
				accessor: "",
				Cell: row => (
					<div>
						<button type="button"
								onClick={() => this.handleEdit(row)}
								data-toggle="tooltip" data-placement="bottom" title="Düzenle"
								style={{background: 'linear-gradient(rgb(120, 177, 215), rgb(120, 177, 215))'}}
								rel="tooltip"
								disabled={!hasUserRight(UserRightsEnum.settings.xslt.update,this.props.currentUser)}
								className="Btn btn-icon">
							<i className="far fa-edit"/>
						</button>
						<button type="button"
								data-toggle="tooltip" data-placement="bottom"
								title="Önizle"
								style={{background: 'linear-gradient(rgba(159, 208, 55, 0.6), rgb(159, 208, 55))'}}
								rel="tooltip" className="Btn btn-icon"
								disabled={!hasUserRight(UserRightsEnum.settings.xslt.view,this.props.currentUser)}
								onClick={() => this.handleShow(row)}>
							<i className="fa fa-eye"/>
						</button>
						<button type="button"
								data-toggle="tooltip" data-placement="bottom"
								title="İndir"
								style={{background: 'linear-gradient(rgba(247, 24, 24, 0.6), rgb(228, 9, 9))'}}
								rel="tooltip" className="Btn btn-icon"
								disabled={!hasUserRight(UserRightsEnum.settings.xslt.view,this.props.currentUser)}
								onClick={() => this.handleDownload(row)}>
							<i className="fa fa-download"/>
						</button>
						<button type="button" onClick={() => this.openDeleteConfirmModal(row)} rel="tooltip"
								className="Btn btn-icon"
								disabled={!hasUserRight(UserRightsEnum.settings.xslt.delete,this.props.currentUser)}
								style={{background: 'linear-gradient(rgba(125, 125, 125, 0.57), rgb(111, 111, 111))'}}>
							<i className="far fa-trash-alt"></i>
						</button>
					</div>
				)
			}
		];
		return (
			<div className="row baseBackground">
				<NavBarKS offsetWidth={this.props.offsetWidth} innerWidth={window.innerWidth} name='xsltList'>
					<StickButton position="leftSide"
								 disabled={this.state.serviceList.length===0 || !hasUserRight(UserRightsEnum.settings.xslt.create,this.props.currentUser)}
								 onClick={this.handleCreate} title="Yeni XSLT Oluştur" label="Yeni XSLT Oluştur" className="stickButton plus-circle"/>

					<StickButton position="leftSide"
								 disabled={this.state.serviceList.length===0 || !hasUserRight(UserRightsEnum.settings.xslt.create,this.props.currentUser)}
								 onClick={this.handleUpload}  label="Yeni XSLT Yükle" title="Yeni XSLT Yükle" className='stickButton upload'/>
				</NavBarKS>

				{this.state.alert}
				{/*{this.state.isLoading&&
				{/*{this.state.isLoading&&
				<ReactLoading type="spinningBubbles" style={{width:"70px", height: "70px", margin: "20px auto 0 auto", fill: "#888"}}/>
				}*/}
				<div className="col-md-12 satirBasi">
					<div className="">
						<div className="card-header ">
							<h4 className="card-title">XSLT Listesi</h4>
						<div className="card-body"></div>
						<div className="col pl-0 pr-0 pt-2 pb-2 m-0 card-body" style={{paddingTop:'20px'}}>
						<div className="col-sm-3 col-lg-1" style={{paddingLeft:'0px'}}>
							<label
								style={{textAlign : 'left',fontWeight:'bold',paddingTop:'4px'}}
							>XSLT Türü:</label>
						</div>
							<div className="col-sm-9 p-0 col-lg-5">
								<Select
								 value={this.state.type}
								 clearable={false}
								 searchable={false}
								 placeholder="Tümü"
								 onChange={e => {this.setState({type: e.value}, () => this.fetchData(undefined, undefined, 0, this.state.size))}}
								 options={allServices && Array.isArray(allServices) && allServices.map((type) => ({value: type.value, label: type.label}))}
								/>
							</div>
						</div>
							<Table
								columns={columns}
								content={this.state.xslts}
								total={this.state.total}
								page={this.state.page}
								size={this.state.size}
								loading={this.state.loading}
								options={["5", "10", "20", "50", "100"]}
								fetchData={this.fetchData}
							/>
						</div>
					</div>
				</div>
				{this.state.isOpen &&
				<XsltEditCreateModal modal={this.state.isOpen}
									 listener={this.toggleModal}
									 xslt={this.state.modelXslt}
									 serviceList={this.state.serviceList}
									 customerId={this.state.customerId}
				/>
				}
				{this.state.mediaModal &&
				<MediaViewer modal={this.state.mediaModal}
							 url={this.state.url}
							 title={this.state.title}
							 listener={this.setMediaViewer}
				/>
				}
			</div>
		);
	}


}

export default XsltList;